import { useEffect } from 'react';

import { useOpenSearchContext } from './useOpenSearchContext';

const DEFAULT_PAGE_SIZE = 20;

const useInfiniteHits = <T>() => {
  const {
    pageSize = DEFAULT_PAGE_SIZE,
    hits,
    updateSize,
    totalHits,
    isLoading,
    isFetching,
  } = useOpenSearchContext();
  const isLastPage = hits.length === totalHits;
  const hitsData = hits?.map(
    ({ _source, inner_hits }) =>
      ({
        ..._source,
        siblings: inner_hits?.siblings?.hits?.hits?.map(
          sibling => sibling._source,
        ),
      } as T),
  );

  const loadMore = () => {
    updateSize((prev = pageSize) => prev + pageSize);
  };

  useEffect(() => {
    updateSize(pageSize);

    return () => {
      updateSize(undefined);
    };
  }, [pageSize]);

  return { hits: hitsData, isLastPage, loadMore, isLoading, isFetching };
};

export { useInfiniteHits };
